// JavaScript for handling cookie consent actions
document.getElementById('accept-all-cookies').addEventListener('click', function(event) {
  event.preventDefault(); // Prevent link default behavior
  // Set a cookie to indicate consent
  document.cookie = "cookieConsent=true; path=/; max-age=31536000";
  // Hide the cookie consent bar
  document.getElementById('cookie-consent-bar').style.display = 'none';
});
